import api from './api';

export interface LeadEntitlements {
  planName: string;
  monthlyLeadLimit: number | null;
  baseMonthlyLeadLimit?: number | null;
  planRemaining?: number | null;
  walletCredits?: number;
  totalAvailable?: number | null;
  used: number;
  remaining: number | null;
  showContact: boolean;
  showPrice: boolean;
  topUpAllowed?: boolean;
  earlyAccessMinutes?: number;
  teamSeats?: number;
  canExport?: boolean;
  prioritySupport?: boolean;
}

export interface UnlockResponse {
  rideId: string;
  contactName: string;
  contactNumber: string;
  price: string;
  originalMessage: string;
  entitlements: LeadEntitlements;
}

export interface UnlockedRideItem {
  unlockId: string;
  unlockedAt: string;
  monthKey: string;
  creditSource?: 'plan' | 'wallet' | 'unlimited' | 'legacy';
  creditsCharged?: number;
  ride: {
    id: string;
    from: string;
    to: string;
    time: string;
    price: string;
    status: string;
    priority: 'low' | 'normal' | 'high';
    contactName: string;
    contactNumber: string;
    originalMessage: string;
    createdAt: string;
  };
}

export interface MyUnlocksResponse {
  unlocks: UnlockedRideItem[];
  stats: {
    totalUnlocked: number;
    ridesWon: number;
    thisMonth: number;
  };
  pagination: {
    page: number;
    limit: number;
    total: number;
    pages: number;
  };
}

export const fetchLeadEntitlements = async (): Promise<LeadEntitlements> => {
  const response = await api.get('/api/lead-access/entitlements');
  return response.data;
};

export const fetchMyUnlocks = async (page = 1, limit = 10): Promise<MyUnlocksResponse> => {
  const response = await api.get('/api/lead-access/my-unlocks', { params: { page, limit } });
  return response.data;
};

export const unlockLead = async (rideId: string): Promise<UnlockResponse> => {
  const response = await api.post(`/api/lead-access/${rideId}/unlock`);
  return response.data;
};

export interface ConfirmTakenResponse {
  message: string;
  status: string;
  driverConfirmedAt: string;
}

export const confirmRideTaken = async (rideId: string): Promise<ConfirmTakenResponse> => {
  const response = await api.post(`/api/lead-access/${rideId}/confirm-taken`);
  return response.data;
};
